import * as React from 'react';
import defaultAvatar from 'src/images/man-303792_640.png';

interface IProfilePictureProps {
    size: number;
    avatar: string;
    className?: string;
}

export default (props: IProfilePictureProps) => {
    const shadowRadius = Math.floor(Math.cbrt(props.size));

    const croppedStyle: React.CSSProperties = {
        width: props.size,
        height: props.size,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'rgba(200, 200, 200, 50)',
        boxShadow: `0 0 ${shadowRadius}px #AAA`,
        backgroundColor: '#dfdfdf',
    };

    const profilePicStyle: React.CSSProperties = {
        display: 'inline',
        margin: '0 auto',
        marginTop: 0,
        marginRight: 'auto',
        marginBottom: 0,
        height: '100%',
        width: 'auto',
    };

    const url = props.avatar;

    return (
        <div className={props.className || ''} style={croppedStyle}>
            <img style={profilePicStyle} src={url ? url : defaultAvatar} alt="avatar" />
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/client/shared/ProfilePicture.tsx